import {_api_carcloud} from '@/service/axios'


// 找子节点
const findChild = (datas, pid, parent, id) => {
  const arr = []
  for (const item of datas) {
    if (item[parent] === pid) {
      item.children = findChild(datas, item[id], parent, id)
      arr.push(item)
    }
  }
  return arr
}

export const transTree = (datas, parent = 'parent', id = '_id') => {
  if (datas.length) {
    return findChild(datas, null, parent, id)// 数组
  }
  return []
}


/**
 * 校验是否为空 isEmpty
 * @param {*} objVal
 * isEmpty([]) // true
 */
export const isEmpty = objVal => {
  if (
    objVal == "" ||
    objVal == "''" ||
    objVal == "" ||
    objVal == "null" ||
    objVal == "{}" ||
    objVal == "[]" ||
    objVal == null ||
    objVal == "'[]'" ||
    objVal == "<null>" ||
    objVal == undefined ||
    objVal == NaN
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * PortalPortal	页表单个人敏感信息显示脱敏处理规则页表单个人敏感信息显示脱敏处理规则
 * 其中包含 姓名脱敏、手机号脱敏、地址脱敏、姓名脱敏、身份证脱敏、护照脱敏
 */
// 姓名脱敏
export const desensitizedName = fullName => {
  if(isEmpty(fullName)) {
    return fullName;
  }
  let length = fullName.length;
  if (length == 1) {
    return fullName;
  } else if (length == 2 || length == 4) {
    return fullName.substring(0,length/2).concat("".padEnd(length/2, "*"));
  } else {
    return fullName.substring(0,1) + "".padEnd(length-2, "*") + fullName.substring(length-1,length);
  }
};
// 手机号码中间4位脱敏
export const desensitizedMobile = mobile => {
  if(isEmpty(mobile) || (mobile.length != 11)) {
    return mobile;
  }
  var pat= /(\d{3})\d*(\d{4})/
  return mobile.replace(pat,'$1****$2');
};
// 地址脱敏
export const desensitizedAddress = address => {
  if(isEmpty(address)) {
    return address;
  }
  var pat= /(\d+)/g;
  return address.replace(pat,'*');
};
//护照后*位脱敏
export const desensitizedIdPassport = (val,length = 2) => {
  if (isEmpty(val)) {
    return val;
  }
  if(val.length <= length){
    return "".padEnd(val.length, "*");
  }
  return String(val).substring(0,String(val).length - length).concat("".padEnd(length, "*"));
};
//身份证脱敏
export const desensitizedIdEncrypt = (val) => {
  if(isEmpty(val) || val.length < 6) {
    return val;
  }
  return val.replace(/^(.{6})(?:\d+)(.{4})$/,  "\$1****\$2");
};

export const DateFilter = (value, YDMFlag = false) => {
  if (value) {
    let d = null;
    if (typeof value === "string") {
      if (value.length === 13) {
        d = new Date(parseInt(value));
      } else {
        d = new Date(value);
      }
    } else if (typeof value === "number") {
      d = new Date(value);
    } else {
      d = value;
    }
    if (d) {
      const date = {
        Y: d.getFullYear(),
        M: d.getMonth() > 8 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1),
        D: d.getDate() > 9 ? d.getDate() : "0" + d.getDate(),
        h: d.getHours() > 9 ? d.getHours() : "0" + d.getHours(),
        m: d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes(),
        s: d.getSeconds() > 9 ? d.getSeconds() : "0" + d.getSeconds()
      };
      if (!YDMFlag) {
        return (
          date.Y +
          "-" +
          date.M +
          "-" +
          date.D +
          " " +
          date.h +
          ":" +
          date.m +
          ":" +
          date.s
        );
      }
      return date.Y + "-" + date.M + "-" + date.D;
    }
    return "";
  }
  return "";
};

export const formatTime = (val, ydm = false) => {
  if (!val) {
    return ""; // --
  }
  const date = typeof val === "object" ? val : new Date(val);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  if (ydm) {
    return [year, month, day].map(formatNumber).join("-");
  }
  return (
    [year, month, day].map(formatNumber).join("-") +
    " " +
    [hour, minute, second].map(formatNumber).join(":")
  );
};

export const formatTimeEnd = (val, ydm = false) => {
  if (!val) {
    return ""; // --
  }
  const date = typeof val === "object" ? val : new Date(val);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = '23';
  const minute = '59';
  const second = '59';
  if (ydm) {
    return [year, month, day].map(formatNumber).join("-");
  }
  return (
    [year, month, day].map(formatNumber).join("-") +
    " " +
    [hour, minute, second].map(formatNumber).join(":")
  );
};

const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

// 获取地址 省 数据处理
export const getAreaList = async () => {
  const params = {
    level: "PROVINCE",
    parentId: "100000",
    boundary: false
  };
  let req =  await _api_carcloud.get("/backend-api/v1.0/division/find", {
    params
  });
  const result = req.data;
  if (result.code === "000000") {
    return provinceTidy(result.data);
  } else {
    return [];
  }
};
export const provinceTidy = (datas, children = true) => {
  let procinceData = [];
  const noChildRen = ['710000', '810000', '820000', '120200', '310200', '500200'];
  datas.map(item => {
    let ii = {
      value: item.id,
      label: item.name,
      level: item.level,
      center: item.center
    };
    if (children && noChildRen.findIndex(io => io === item.id) === -1) {
      ii.children = [];
      ii.loading = false;
    }
    procinceData.push(ii);
  });
  return procinceData;
};
